"use client";
import AnimatedText from "@/components/common/AnimatedText";
import Link from "next/link";
import { useEffect, useState } from "react";

export default function Events() {
  const [eventsData, setEventsData] = useState([]);
  const [cinemaContent, setCinemaContent] = useState(null);

  useEffect(() => {
    // Fetch events
    const fetchEvents = async () => {
      try {
        const response = await fetch("/api/events");
        if (response.ok) {
          const data = await response.json();
          setEventsData(data);
        }
      } catch (error) {
        console.error("Failed to fetch events:", error);
      }
    };

    // Fetch cinema category content (image, title, description)
    const fetchCinema = async () => {
      try {
        const response = await fetch("/api/movies");
        if (response.ok) {
          const data = await response.json();
          if (data.cinemaContent) {
            setCinemaContent(data.cinemaContent);
          }
        }
      } catch (error) {
        console.error("Failed to fetch cinema content:", error);
      }
    };

    fetchEvents();
    fetchCinema();
  }, []);

  const currentSection = eventsData.length > 0 ? eventsData[0] : null;

  return (
    <>
      <section
        id="about"
        className="about-section fix section-padding scrollSpySection pb-0"
      >
        <div className="container">
          <div className="about-wrapper">
            <div className="row justify-content-center">
              <div className="col-lg-9 align-self-center text-center">
                <div className="about-content">
                  <div className="section-title pb-0 mb-0">
                    <h6 className="splt-txt wow">
                      {currentSection?.event_title}
                    </h6>
                  </div>

                  <h2 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".4s">
                    <AnimatedText text="Feel the Excitement" />
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="experience-section">
        <div className="container experience-container">
          <div className="row">
            {/* Left: Event category cards */}
            <div className="col-lg-8">
              <div className="row py-4 evtbox">
                {currentSection?.events?.map((item, index) => (
                  <div className="col-lg-6 col-md-6" key={item._id || index}>
                    <div className="image-anime">
                      <Link
                        href={`/home/${item.category_title
                          .toLowerCase()
                          .replace(/\s+/g, "-")}`}
                        className="text-decoration-none d-block w-100 h-100"
                        style={{ position: "relative", zIndex: 10 }}
                      >
                        <div className="experience-card">
                          <img
                            src={item.category_image}
                            alt={item.category_title}
                            className="experience-image"
                          />

                          <div className="experience-overlay">
                            <h3 className="experience-title">
                              <span className="experience-icon">🎪</span>
                              {item.category_title}
                            </h3>

                            <p className="experience-desc">
                              {item.category_description}
                            </p>

                            <span className="experience-link">
                              See More <span className="arrow">→</span>
                            </span>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right: Cinema card — fetched from /api/movies cinemaContent */}
            <div className="col-lg-4">
              <div className="row py-4">
                <div className="col-lg-12">
                  <div className="image-anime">
                    <Link
                      href="/cinema"
                      className="text-decoration-none d-block w-100 h-100"
                      style={{ position: "relative", zIndex: 10 }}
                    >
                      <div className="experience-card">
                        <img
                          src={
                            cinemaContent?.category_image ||
                            "assets/img/Cinemas.jpeg"
                          }
                          alt={
                            cinemaContent?.category_title ||
                            "Movies & Live Entertainment"
                          }
                          className="experience-image"
                        />

                        <div className="experience-overlay">
                          <h3 className="experience-title">
                            <span className="experience-icon">🎬</span>
                            {cinemaContent?.category_title ||
                              "Movies & Live Entertainment"}
                          </h3>

                          <p className="experience-desc">
                            {cinemaContent?.category_description ||
                              "Relax in our cozy cinema or catch live performances that bring the park to life."}
                          </p>

                          <span className="experience-link">
                            See More <span className="arrow">→</span>
                          </span>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
